import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PixModel } from '../models/paymentPix.model';
import { AppService } from '../app.service';
import { ResponsibleModel } from '../models/responsible.model';

@Injectable()
export class PixService extends AppService<ResponsibleModel>{
  private readonly baseUrl = 'Pagamento/RecarregarCartaoCashlessOnline/Pix';

  constructor(http: HttpClient) {
    super(http);
  }
 
  async paymentPix(request: PixModel) {
    const result = await this.postAsync(this.baseUrl, request);
    return result;
  }

  async getPixStatus(paymentId: string) {
    const result = await this.getAsync(`public/Pix/${paymentId}`);
    return result;
  }

}


 


// WEBPACK FOOTER //
// /usr/src/app/src/app/services/paymentPix.service.ts